import { saveUTMParams } from "../helper";
export const LandingPageService = {
    getIP: async () => {
        try {
            const URL = `http://www.geoplugin.net/json.gp`;
            let resp = await fetch(URL);
            resp = await resp.json();
            return resp;
        } catch (error) {
            console.error(error.message);
        }
    },
    getNumberFromHeader: async (url) => {
        try {
            let resp = await fetch(url);
            let number = "";
            resp = await resp.json();
            localStorage.setItem("userTelco", resp.status === 1 && resp.data.msisdn > 0 ? "tp" : "")
            if (resp.status !== 1) { 
                resp = await fetch("http://cricket.jazz.com.pk/test/get_header_phone/");
                resp = await resp.json();
                localStorage.setItem("userTelco", resp.status === 1 && resp.phone.length > 0 ? "jazz" : "")
                number = resp.phone;
            } else {
                number = resp.data.msisdn;
            }
            
            if (number == null || number.length === 0) {
                resp.data = {}
                number = resp.data.msisdn;
            } 
            saveUTMParams(window.utm, "install", resp.status === 1 ? number : "")
            if (resp.data) {

            } else {
                resp.data = {};
            }
            resp.data.msisdn = number;
            return resp;
        } catch (error) {
            console.error("Error in get number from header", error.message);
        }
    }
}